export default {
    brand: {
        product_name: 'Fleet',
        tagline:      'Zajem sledilnikov',
    },
    nav: {
        map:           'Karta',
        vehicles:      'Vozila',
        drivers:       'Vozniki',
        costs:         'Stroški',
        trips:         'Poti',
        stats:         'Statistika',
        zones:         'Območja',
        alerts:        'Opozorila',
        reminders:     'Opomniki',
        reports:       'Poročila',
        install_guide: 'Navodila za namestitev',
        configuration: 'Nastavitve',
        settings:      'Račun in uporabniki',
        collapse:      'Skrči meni',
        expand:        'Razširi meni',
        version_web:   'Konzola {version}',
        version_api:   'API {version}',
    },
    general: {
        add:      'Dodaj',
        edit:     'Uredi',
        cancel:   'Prekliči',
        save:     'Shrani',
        close:    'Zapri',
        refresh:  'Osveži',
        filter:   'Filter',
        search:   'Iskanje',
        loading:  'Nalaganje …',
        copy:     'Kopiraj',
        copied:   'Kopirano',
        none:     '—',
        settings: 'Nastavitve',
        confirm:  'Potrdi',
        delete:   'Izbriši',
        sign_out: 'Odjava',
    },
    auth: {
        login:     'Prijava',
        username:  'Uporabniško ime',
        password:  'Geslo',
        sign_in:   'Prijavi se',
        failed:    'Prijava ni uspela',
        signed_in: 'Prijavljeni ste kot {name}',
        or:            'ali',
        password_show: 'Pokaži geslo',
        password_hide: 'Skrij geslo',
    },
    settings: {
        settings:    'Nastavitve',
        subtitle:    'Vaš račun, ljudje, ki lahko odprejo to konzolo, in ključi, s katerimi se prijavljate.',
        account:     'Račun',
        reader_note: 'Prijavljeni ste kot bralec: v konzoli vidite vse, spreminjati pa ne morete ničesar. Spremembe ureja skrbnik.',
    },
    password: {
        change:        'Spremeni geslo',
        current:       'Trenutno geslo',
        new:           'Novo geslo',
        repeat:        'Ponovite novo geslo',
        mismatch:      'Gesli se ne ujemata',
        wrong_current: 'Trenutno geslo ni pravilno',
        changed:       'Geslo je spremenjeno',
        failed:        'Gesla ni bilo mogoče spremeniti',
    },
    user: {
        users:              'Uporabniki',
        subtitle:           'Vsi, ki lahko odprejo to konzolo.',
        add:                'Dodaj uporabnika',
        edit:               'Uredi uporabnika',
        delete:             'Izbriši uporabnika',
        name:               'Ime',
        username:           'Uporabniško ime',
        role:               'Vloga',
        role_admin:         'Skrbnik',
        role_reader:        'Bralec',
        role_help:          'Bralec vse vidi in ničesar ne spreminja; skrbnik poleg tega ureja vozila in upravlja uporabnike.',
        created:            'Ustvarjen',
        password:           'Geslo',
        password_optional:  'Novo geslo',
        password_rule:      'Vsaj 12 znakov. Napadalca stane dolžina, ne števke in posebni znaki.',
        password_keep:      'Pustite prazno, če gesla ne spreminjate.',
        password_too_short: 'Geslo mora imeti vsaj 12 znakov',
        username_too_short: 'Vsaj 3 znaki',
        name_too_long:      'Največ 64 znakov',
        username_taken:     'To uporabniško ime je že zasedeno',
        last_admin:         'Zadnjega skrbnika ni mogoče izbrisati ali spremeniti v bralca',
        cannot_delete_self: 'Svojega računa ne morete izbrisati',
        confirm_delete:     'Izbrišem račun uporabnika {name}? Z njim gredo tudi njegovi ključi za prijavo.',
        deleted:            'Račun je izbrisan',
        delete_failed:      'Računa ni bilo mogoče izbrisati',
        empty:              'Ni še nobenega računa.',
        you:                'vi',
    },
    passkey: {
        passkeys:       'Ključi za prijavo',
        subtitle:       'Ključi, s katerimi se prijavljate — telefon, prenosnik, strojni ključ.',
        add:            'Dodaj ključ',
        continue:       'Naprej',
        delete:         'Odstrani ključ',
        name:           'Ime',
        name_help:      'Poimenujte ga po napravi, na kateri je, da boste kasneje vedeli, katerega odstraniti.',
        name_too_long:  'Največ 60 znakov',
        default_name:   'Ta naprava',
        created:        'Dodan',
        last_used:      'Nazadnje uporabljen',
        never_used:     'še neuporabljen',
        added:          'Ključ je dodan',
        removed:        'Ključ je odstranjen',
        failed:         'Ključa ni bilo mogoče dodati',
        delete_failed:  'Ključa ni bilo mogoče odstraniti',
        confirm_delete: 'Odstranim ključ „{name}“? S tem ključem se ne boste mogli več prijaviti.',
        empty:          'Ključa za prijavo še nimate.',
        sign_in:        'Prijava s ključem',
        sign_in_failed: 'Ta ključ ni bil sprejet',
        unavailable:    'Ključi za prijavo na tej namestitvi niso vklopljeni — potrebujejo lastno domeno prek HTTPS.',
        unsupported:    'Ta brskalnik ne podpira ključev za prijavo. Potrebujejo varno povezavo (HTTPS).',
    },
    service_key: {
        keys:             'Ključi API',
        subtitle:         'Ključi, s katerimi se v konzolo prijavljajo drugi sistemi — najprej podjetniški portal. Vsak ključ ima skrbniške pravice.',
        add:              'Nov ključ',
        add_help:         'Poimenujte ga po sistemu, ki ga bo uporabljal, da boste pozneje vedeli, katerega preklicati.',
        name:             'Ime',
        name_placeholder: 'Portal',
        name_too_long:    'Največ 64 znakov',
        create:           'Ustvari ključ',
        prefix:           'Začetek ključa',
        created:          'Ustvarjen',
        last_used:        'Nazadnje uporabljen',
        never_used:       'še neuporabljen',
        status:           'Stanje',
        active:           'Aktiven',
        revoked:          'Preklican',
        environment:      'Iz okolja',
        environment_name: 'Ključ {n} iz okolja',
        environment_note: 'Ključi iz okolja so zapisani v spremenljivki SERVICE_API_KEYS v datoteki /opt/fleet/.env na strežniku. Tukaj jih ni mogoče preklicati — odstranite jih v tej datoteki in znova objavite fleet-api.',
        revoke:           'Prekliči',
        revoke_title:     'Preklic ključa',
        revoke_confirm:   'Prekliči ključ',
        confirm_revoke:   'Prekličem ključ „{name}“ ({prefix}…)? Sistem, ki ga uporablja, se z njim ne bo več mogel prijaviti. Preklica ni mogoče razveljaviti.',
        revoked_toast:    'Ključ je preklican',
        revoke_failed:    'Ključa ni bilo mogoče preklicati',
        created_toast:    'Ključ je ustvarjen',
        create_failed:    'Ključa ni bilo mogoče ustvariti',
        empty:            'Ključev API še ni.',
        result_title:     'Nov ključ API: {name}',
        result_once:      'Ključ je prikazan samo zdaj',
        result_warning:   'Kopirajte ga in ga shranite v sistem, ki ga bo uporabljal. Pozneje ga ne bo mogoče več videti — če ga izgubite, ga prekličite in ustvarite novega.',
        result_usage:     'Authorization: Bearer <ključ>',
        done:             'Ključ je shranjen, zapri',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetel način',
        switch_to_dark:  'Preklopi na temen način',
    },
    density: {
        label:   'Gostota prikaza',
        compact: 'Zgoščen',
        normal:  'Normalen',
    },
    locale: {
        label: 'Jezik',
        en:    'Angleščina',
        sl:    'Slovenščina',
        hr:    'Hrvaščina',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Nimate dostopa',
        forbidden:     'Dejanje ni dovoljeno',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri shranjevanju',
        on_load:       'Podatkov ni bilo mogoče naložiti',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno shranjeno',
    },
    validation: {
        required: 'To polje je obvezno',
    },
    time: {
        now:     'zdaj',
        never:   'nikoli',
        minutes: '{count} min',
        hours:   '{count} h',
        days:    '{count} dni',
        ago:     'pred {value}',
    },
    device: {
        devices:        'Naprave',
        device:         'Naprava',
        imei:           'IMEI',
        state:          'Stanje',
        online:         'Povezana',
        offline:        'Nepovezana',
        first_seen:     'Prvič videna',
        last_seen:      'Zadnjič videna',
        last_record:    'Zadnji zapis',
        last_position:  'Zadnji položaj',
        last_speed:     'Zadnja hitrost',
        record_count:   'Zapisi',
        packet_count:   'Paketi',
        counts:         'Zapisi / paketi',
        empty_title:    'Nobena naprava se še ni javila',
        empty_body:     'Strežnik posluša na vratih TCP 5027 (Codec 8 Extended). Naprava se prikaže tukaj, brž ko pošlje prvi paket — najprej se predstavi z IMEI, nato pošlje zapise.',
        not_found:      'Naprave s tem IMEI ni',
        auto_refresh:   'Samodejno osveževanje',
        refresh_every:  'Osvežuje se vsakih {seconds} s',
        waiting:        'Čaka',
        waiting_title:  'Čaka na prvi paket',
        waiting_body:   'Vozilo je vpisano, njegov sledilnik pa se še ni javil. Ko pošlje prvi paket, se tu pokažejo časi, položaj in parametri — do takrat ni česa prikazati.',
        asleep:         'spi',
        sleep_none:     'brez spanja',
        sleep_gps:      'spanje GPS',
        sleep_deep:     'globoko spanje',
        sleep_online:   'spanje na zvezi',
        sleep_ultra:    'ultra spanje',
    },
    driver: {
        drivers:              'Vozniki',
        subtitle:             'Seznam voznikov, ki jih knjiga voženj in dodelitve vozil navajata.',
        add:                  'Dodaj voznika',
        edit:                 'Uredi voznika',
        name:                 'Ime in priimek',
        phone:                'Telefon',
        email:                'E-pošta',
        employee_no:          'Št. zaposlenega',
        tag:                  'Oznaka obeska',
        tag_help:             'Za poznejšo samodejno prepoznavo voznika (iButton, RFID ali Bluetooth obesek). Zaenkrat se ne uporablja.',
        note:                 'Opomba',
        active:               'Aktiven',
        inactive:             'Neaktiven',
        show_inactive:        'Pokaži neaktivne',
        search:               'Išči po imenu, telefonu ali št. zaposlenega …',
        vehicles:             'Vozila',
        empty:                'Ni voznikov.',
        unknown:              'Neznan voznik',
        delete:               'Izbriši voznika',
        confirm_delete:       'Ali res želiš izbrisati voznika {name}?',
        confirm_keeps:        'Voznik ima zgodovino voženj, zato bo deaktiviran, ne izbrisan.',
        deleted:              'Voznik je odstranjen s seznama.',
        delete_failed:        'Voznika ni bilo mogoče izbrisati',
        tag_taken:            'Ta oznaka obeska je že dodeljena drugemu vozniku.',
        name_too_long:        'Največ 80 znakov',
        phone_invalid:        'Vpiši telefonsko številko — števke, presledki in + - / ( ).',
        email_invalid:        'Vpiši veljaven e-poštni naslov.',
        employee_no_too_long: 'Največ 32 znakov',
        tag_too_long:         'Največ 64 znakov',
        note_too_long:        'Največ 200 znakov',
    },
    vehicle: {
        photo_pick:     'Naloži fotografijo',
        photo_clear:    'Odstrani fotografijo',
        photo_drop:     'Povleci fotografijo sem ali jo izberi — JPEG, PNG ali WebP',
        photo_failed:   'Fotografije ni bilo mogoče shraniti',
        photo_url_help: 'Povezava do slike, ki jo smeš uporabiti; naložena fotografija jo nadomesti.',
        drivetrain:      'Pogon',
        drivetrain_auto: 'Ugotovi iz podatkov',
        drivetrain_ice:  'Motor z notranjim izgorevanjem',
        drivetrain_ev:   'Električno',
        drivetrain_phev: 'Priključni hibrid',
        drivetrain_help: 'Pri vozilu, ki že oddaja, pusti prvo možnost — kar naprava pošilja, pove več kot spomin.',
        vehicle:        'Vozilo',
        edit:           'Uredi vozilo',
        name:           'Ime',
        plate:          'Registrska oznaka',
        body:           'Karoserija',
        colour:         'Barva',
        colour_help:    'Izberite eno od barv ali vpišite šestnajstiško vrednost.',
        colour_invalid: 'Vpišite šestnajstiško barvo, na primer #1e4fa3',
        photo_url:      'Povezava do fotografije',
        photo_invalid:  'Vpišite naslov, ki se začne s http:// ali https://',
        name_too_long:  'Največ 64 znakov',
        plate_too_long: 'Največ 16 znakov',
        add:                  'Dodaj vozilo',
        added:                'Vozilo je dodano.',
        add_failed:           'Vozila ni bilo mogoče dodati',
        imei:                 'IMEI sledilnika',
        imei_help:            'Petnajst števk z nalepke na sledilniku; isti IMEI pokaže tudi Teltonika Configurator.',
        imei_length:          'IMEI ima 15 števk.',
        imei_invalid:         'IMEI ni veljaven — preveri zadnjo števko.',
        imei_exists:          'Vozilo s tem IMEI že obstaja.',
        imei_authorises:      'S tem dovoliš sledilniku s tem IMEI, da se poveže.',
        name_required:        'Vpiši ime vozila.',
        delete:               'Izbriši vozilo',
        delete_blocks:        'Sledilnik tega vozila se ne bo mogel več povezati.',
        delete_keeps:         'Podatki ostanejo shranjeni; če vozilo z istim IMEI dodaš znova, se spet prikažejo.',
        delete_purge:         'Izbriši tudi vse podatke tega vozila (zapise, poti, knjigo voženj, opozorila). Tega ni mogoče razveljaviti.',
        delete_confirm_plate: 'Za potrditev vpiši registrsko oznako.',
        delete_confirm_imei:  'Za potrditev vpiši zadnjih šest števk IMEI.',
        deleted:              'Vozilo je izbrisano.',
        delete_failed:        'Vozila ni bilo mogoče izbrisati',
        empty_add:            'Dodaj vozilo in s tem dovoli njegovemu sledilniku, da se poveže.',
        driver:                'Voznik',
        no_driver:             'Brez voznika',
        assign_driver:         'Dodeli voznika',
        driver_since:          'Velja od',
        driver_since_now:      'Od zdaj',
        driver_since_choose:   'Izberi drug čas',
        driver_assigned:       'Voznik je dodeljen.',
        driver_failed:         'Voznika ni bilo mogoče dodeliti',
        driver_history:        'Zgodovina voznikov',
        driver_history_empty:  'To vozilo še ni imelo dodeljenega voznika.',
        driver_from:           'od {from}',
        driver_to:             'do {to}',
        driver_now:            'zdaj',
        driver_show_all:       'Prikaži vse',
        driver_show_less:      'Prikaži manj',
        purchase_value:     'Nabavna vrednost (z DDV)',
        purchase_help:      'Kar je vozilo stalo z DDV — to je osnova za boniteto. Pri najemu vrednost lastnika, pri rabljenem vozilu kar je podjetje res plačalo.',
        purchase_currency:  'Valuta',
        first_use:          'Datum prve uporabe',
        first_use_help:     'Dan, ko je podjetje vozilo pridobilo — ne dan prve registracije. Od njega se šteje letno znižanje bonitete.',
        employer_fuel:      'Delodajalec plačuje gorivo za zasebne vožnje',
        employer_fuel_help: 'Boniteta se v tem primeru poveča za četrtino.',
        benefit_user:       'Uporabnik vozila',
        benefit_user_help:  'Zaposleni, ki ima vozilo za zasebno rabo. Prazno pomeni trenutno dodeljenega voznika.',
        fuel_type:          'Vrsta goriva',
        fuel_type_none:     'Ni določeno',
        fuel_petrol:        'Bencin',
        fuel_diesel:        'Dizel',
        fuel_lpg:           'Plin (LPG)',
        fuel_electric:      'Električno',
        fuel_hybrid:        'Hibrid',
        fuel_phev:          'Priključni hibrid',
        finance:            'Finance',
        finance_help:       'Vidno samo skrbnikom. Prazna polja ne spremenijo ničesar.',
        finance_saved:      'Finančni podatki so shranjeni.',
    },
    body: {
        unknown:   'Ni določeno',
        sedan:     'Limuzina',
        estate:    'Karavan',
        hatchback: 'Kombilimuzina',
        suv:       'SUV',
        van:       'Kombi',
        pickup:    'Poltovornjak',
        truck:     'Tovornjak',
    },
    tab: {
        map:        'Zemljevid',
        parameters: 'Parametri',
        records:    'Zapisi',
        packets:    'Surovi paketi',
        graphs:     'Grafi',
    },
    graph: {
        speed:        'Hitrost glede na omejitev',
        rpm:          'Vrtljaji motorja',
        temperatures: 'Temperature',
        battery:      'Baterija',
        fuel:         'Gorivo',
        consumption:  'Poraba',
        power:        'Moč baterije',
        level:        'Nivo',
        average_consumption: 'Povprečna poraba',
        limit:        'Vpisana omejitev',
        over_limit:   'Prekoračitev',
        charging:     'Polnjenje',
        empty:        'V tem obdobju ni zapisov.',
        not_reported: 'Vozilo ne pošilja teh vrednosti: {names}.',
        window_fit:   'Prilagodi vožnjam',
        window_all:   'Pokaži celotno obdobje',
        window_fitted: 'prilagojeno vožnjam',
        window_earlier: 'Pomakni nazaj',
        window_later: 'Pomakni naprej',
        window_hint:  'Povleci za povečavo, kolešček za približanje, Home za celoto.',
    },
    fleet_map: {
        title:            'Karta',
        all:              'Vsa',
        driving:          'V vožnji',
        stopped:          'Stojijo',
        asleep:           'Spijo',
        offline:          'Brez signala',
        alerting:         'Z opozorilom',
        search:           'Išči po imenu, tablici, IMEI ali kraju …',
        badge_moving:     'Vozi',
        badge_stopped:    'Stoji',
        badge_asleep:     'Spi',
        badge_offline:    'Brez signala',
        badge_never_seen: 'Ni viden',
        state_moving:     'Vozi {duration}',
        state_stopped:    'Stoji {duration}',
        state_asleep:     'Spi {duration}',
        state_offline:    'Brez signala {duration}',
        state_never_seen: 'Še ni bil viden',
        over_a_day:       'Več kot 24 h',
        days:             '{count} dan | {count} dneva | {count} dni | {count} dni',
        open:             'Odpri',
        fit:              'Prilagodi vsem vozilom',
        refreshed:        'zadnja osvežitev {ago}',
        empty:            'Ni vozil, ki bi ustrezala filtru.',
        no_positions:     'Nobeno vozilo še nima znanega položaja.',
        hide_list:        'Skrij seznam',
        show_list:        'Pokaži seznam',
        unsupported:      'Ta različica API-ja še ne pozna karte flote. Vse drugo v konzoli deluje kot prej.',
        to_vehicles:      'Odpri seznam vozil',
        driver:           'Voznik',
        centre_selected: 'Centriraj izbrano vozilo',
        live_routes:     'Prikaži poti vozil v vožnji',
        drive_distance:  'Pot te vožnje: {km} km',
    },
    logbook: {
        title:               'Knjiga voženj',
        business:            'Službena',
        private:             'Zasebna',
        unclassified:        'Nerazvrščena',
        kind:                'Vrsta vožnje',
        purpose:             'Namen vožnje',
        driver:              'Voznik',
        odometer:            'Stanje števca',
        tracker_odometer:    'števec sledilnika, ne vozila',
        gps_distance:        'Izmerjena razdalja: {km} km',
        edit:                'Uredi vpis',
        edit_trip:           'Uredi vpis za vožnjo {route}',
        saved:               'Shranjeno',
        save_failed:         'Vpisa ni bilo mogoče shraniti.',
        keep:                'Ne spreminjaj',
        bulk_title:          'Označi izbrane vožnje',
        bulk_help:           'Prazna polja pustijo obstoječe vpise pri miru.',
        select:              'Izberi vožnjo',
        select_day:          'Izberi ves dan',
        selected:            'Izbranih: {count}',
        mark_business:       'Označi kot službene',
        mark_private:        'Označi kot zasebne',
        set_purpose:         'Namen…',
        clear_selection:     'Počisti izbor',
        export:              'Izvozi CSV',
        export_failed:       'Izvoza ni bilo mogoče pripraviti.',
        filter:              'Vrsta vožnje',
        all_kinds:           'Vse',
        filter_business:     'Službene',
        filter_private:      'Zasebne',
        filter_unclassified: 'Nerazvrščene',
        totals:              'službeno {business} km · zasebno {private} km · nerazvrščeno {unclassified} km',
        threshold_note:      'Knjiga voženj velja pri pragu 30 min; pri drugem pragu razvrščanje ni mogoče.',
        purpose_too_long:    'Namen vožnje je predolg.',
        driver_too_long:     'Ime voznika je predolgo.',
        from_assignment:     'po dodelitvi',
        driver_filter:       'Voznik',
        all_drivers:         'Vsi vozniki',
        driver_pick:         'Izberi voznika ali vpiši ime',
        driver_help:         'Izberi voznika s seznama ali vpiši ime zunanjega voznika.',
    },
    trips_page: {
        title:        'Poti',
        period:       'Obdobje',
        today:        'Danes',
        yesterday:    'Včeraj',
        last_7:       'Zadnjih 7 dni',
        last_30:      'Zadnjih 30 dni',
        custom:       'Po meri',
        range:        'Od–do',
        vehicles:     'Vozila',
        all_vehicles: 'Vsa vozila',
        stop_label:   'Pot se konča po',
        totals:       'Skupaj: {trips} poti · {km} km · {time} vožnje',
        day_totals:   '{trips} poti · {km} km · {time}',
        empty:        'V izbranem obdobju ni poti.',
        select_trip:  'Izberi pot, da jo vidiš na karti.',
        open_vehicle: 'Odpri vozilo',
        fold_all:     'Strni vse',
        unfold_all:   'Razširi vse',
        fold_day:     'Strni dan {day}',
        unfold_day:   'Razširi dan {day}',
    },
    gps: {
        latitude:   'Zemljepisna širina',
        longitude:  'Zemljepisna dolžina',
        altitude:   'Nadmorska višina',
        angle:      'Smer',
        satellites: 'Sateliti',
        speed:      'Hitrost',
        valid:      'Veljavna določitev',
        invalid:    'Brez določitve',
        no_fix:     'Naprava še ni poslala veljavne določitve položaja.',
    },
    track: {
        title:               'Sled',
        period:              'Obdobje',
        last_hour:           'Zadnja ura',
        last_day:            'Zadnjih 24 h',
        last_week:           'Zadnjih 7 dni',
        points:              'Točk: {count}',
        empty:               'V izbranem obdobju ni veljavnih določitev položaja.',
        attribution:         '© Prispevkarji OpenStreetMap',
        attribution_tomtom:  '© TomTom',
        attribution_traffic: 'Promet © TomTom',
        zoom:                'Povečava {zoom}',
        zoom_in:             'Približaj',
        zoom_out:            'Oddalji',
        fit:                 'Prilagodi sledi',
        centre_vehicle:      'Centriraj vozilo',
        traffic:             'Promet',
        traffic_legend:      'Plast prometa pobarva vsako cesto po tem, kako tekoče se vozi — zelena teče, oranžna se upočasnjuje, rdeča se vleče, temno rdeča stoji. Osveži se vsaki dve minuti.',
        speed_chart:         'Hitrost',
        chart_show:          'Pokaži graf hitrosti',
        chart_hide:          'Skrij graf hitrosti',
    },
    cost: {
        title:             'Stroški',
        add:               'Dodaj strošek',
        edit:              'Uredi strošek',
        added:             'Strošek je dodan.',
        saved:             'Strošek je shranjen.',
        deleted:           'Strošek je izbrisan.',
        save_failed:       'Stroška ni bilo mogoče shraniti',
        delete_failed:     'Stroška ni bilo mogoče izbrisati',
        delete_confirm:    'Izbrišem ta strošek? Priložen račun gre z njim.',
        empty:             'V izbranem obdobju ni stroškov.',
        export:            'Izvozi CSV',
        export_failed:     'Izvoza ni bilo mogoče pripraviti',
        cat_fuel:          'Gorivo',
        cat_charging:      'Polnjenje',
        cat_service:       'Servis',
        cat_tyres:         'Pnevmatike',
        cat_insurance:     'Zavarovanje',
        cat_registration:  'Registracija',
        cat_vignette:      'Vinjeta',
        cat_toll:          'Cestnina',
        cat_parking:       'Parkirnina',
        cat_wash:          'Pranje',
        cat_fine:          'Kazen',
        cat_leasing:       'Lizing',
        cat_other:         'Drugo',
        tab_costs:         'Stroški',
        tab_overview:      'Pregled',
        tab_benefit:       'Boniteta',
        period:            'Obdobje',
        range:             'Obdobje po meri',
        this_month:        'Ta mesec',
        last_month:        'Prejšnji mesec',
        this_year:         'Letos',
        last_12:           'Zadnjih 12 mesecev',
        custom:            'Po meri',
        all_vehicles:      'Vsa vozila',
        all_categories:    'Vse kategorije',
        all_drivers:       'Vsi vozniki',
        vehicle:           'Vozilo',
        date:              'Datum',
        category:          'Kategorija',
        amount:            'Znesek',
        currency:          'Valuta',
        vat_rate:          'Stopnja DDV',
        vat_none:          'Ni navedena',
        quantity:          'Količina',
        unit:              'Enota',
        unit_price:        'Cena na enoto',
        full_tank:         'Poln rezervoar',
        full_tank_help:    'Poraba se da pošteno izmeriti samo med dvema polnima rezervoarjema — kar gre vmes noter, je natanko to, kar je bilo porabljeno.',
        odometer:          'Stanje števca',
        odometer_help:     'Predlagano je tisto, kar je vozilo javilo na ta dan. Lahko popraviš.',
        odometer_unknown:  'Vozilo tega dne ni javilo stanja števca.',
        supplier:          'Dobavitelj',
        document_no:       'Št. računa',
        note:              'Opomba',
        driver:            'Voznik',
        receipt:           'Račun (priloga)',
        receipt_pick:      'Naloži račun',
        receipt_open:      'Odpri račun',
        receipt_clear:     'Odstrani račun',
        receipt_drop:      'Povleci račun sem ali ga izberi — JPEG, PNG, WebP ali PDF, do 5 MB',
        receipt_failed:    'Računa ni bilo mogoče shraniti',
        receipt_saved:     'Račun je priložen.',
        receipt_removed:   'Račun je odstranjen.',
        receipt_after:     'Račun lahko priložiš, ko je strošek shranjen.',
        load_older:        'Naloži starejše',
        total:             'Skupaj',
        records:           'zapisov: {count}',
        mixed_currency:    'Stroški so v različnih valutah; ta konzola jih ne preračunava, zato je skupni znesek le seštevek števil.',
        overview:          'Pregled',
        by_month:          'Po mesecih',
        per_km:            'Strošek na km',
        consumption:       'Poraba',
        consumption_approx: 'Približek — električnega vozila ni mogoče meriti med dvema polnima polnjenjema, zato je to vsa energija na prevožene kilometre.',
        km_driven:         'Prevoženi km',
        km_odometer:       'po števcu vozila',
        km_trips:          'po GPS razdalji voženj',
        km_unknown:        'Vozilo ni javilo prevoženih kilometrov, zato stroška na kilometer ni mogoče izračunati.',
        no_data:           'Za ta pregled ni podatkov.',
        amount_invalid:    'Vpiši znesek, na primer 45,90',
        amount_ambiguous:  'Zneska ni mogoče razbrati — 1,234 je lahko 1,234 ali 1234. Napiši 1234,00 ali 1,23.',
        quantity_invalid:  'Vpiši količino, na primer 41,37',
        quantity_required: 'Pri gorivu in polnjenju je količina obvezna.',
        vehicle_required:  'Izberi vozilo.',
        from_reminder:     'iz opomnika',
        open_reminders:    'Odpri opomnike vozila',
    },
    stats: {
        title:                'Statistika',
        export:               'Izvozi CSV',
        export_failed:        'Izvoza ni bilo mogoče pripraviti',
        failed:               'Statistike ni bilo mogoče naložiti.',
        period:               'Obdobje',
        range:                'Obdobje po meri',
        this_month:           'Ta mesec',
        last_month:           'Prejšnji mesec',
        last_7:               'Zadnjih 7 dni',
        last_30:              'Zadnjih 30 dni',
        custom:               'Po meri',
        all_vehicles:         'Vsa vozila',
        vehicles:             'Vozila',
        all_drivers:          'Vsi vozniki',
        driver_filter:        'Voznik',
        speeding_check:       'Preveri prekoračitve hitrosti',
        window_note:          'Statistika zajema največ {days} dni: vožnje se ob vsakem ogledu na novo izračunajo iz zapisov lokacije, zato je obdobje omejeno kot na strani Poti.',
        window_clamped:       'Izbrano obdobje je daljše od {days} dni, zato je prikazanih zadnjih {days} dni.',
        tab_vehicles:         'Po vozilu',
        tab_drivers:          'Po vozniku',
        tab_days:             'Po dnevih',
        drives:               'Vožnje',
        drives_count:         '{count} vožnja | {count} vožnji | {count} vožnje | {count} voženj',
        no_drives:            'brez voženj',
        vehicles_moved:       'vozila v gibanju: {moved} od {vehicles}',
        km:                   'Kilometri',
        km_split:             'službeno {business} · zasebno {private} · nerazvrščeno {unclassified}',
        business_km:          'Službeno km',
        private_km:           'Zasebno km',
        unclassified_km:      'Nerazvrščeno km',
        driving_time:         'Čas vožnje',
        days_in_window:       '{days} dan v obdobju | {days} dneva v obdobju | {days} dnevi v obdobju | {days} dni v obdobju',
        costs:                'Stroški',
        costs_note:           'iz registra stroškov za dneve obdobja',
        no_costs:             'v obdobju ni vpisanih stroškov',
        cost_per_km:          'Strošek na km',
        per_km_fleet:         'vozila z znanimi prevoženimi kilometri',
        per_km_driver:        'na kilometre, ki jih je prevozil voznik',
        truncated:            'Vozilo je v tem obdobju poslalo več zapisov, kot jih je mogoče prebrati naenkrat, zato najstarejše vožnje manjkajo. Izberi krajše obdobje.',
        speeding_unavailable: 'Omejitev hitrosti ni bilo mogoče dobiti, zato prekoračitve niso preverjene.',
        speeding_found:       'Prekoračitve hitrosti: {events} v {checked} od {drives} voženj.',
        speeding_stopped:     'Za naslednjo vožnjo omejitve niso bile na voljo, zato je preverjanje ustavljeno.',
        speeding_capped:      'Preverjanje je v eni poizvedbi omejeno; za ostale vožnje izberi krajše obdobje ali eno vozilo.',
        speeding_partial:     'Preverjenih {checked} od {drives} voženj',
        speeding_footnote:    'Prekoračitev je vsaj dva zaporedna zapisa nad omejitvijo za več kot {tolerance} km/h — GPS sled, primerjana z zemljevidom, ni dokaz.',
        footnote:             'Kilometri so po števcu vozila, kjer ga je vozilo javilo, sicer po GPS razdalji. Vožnja šteje na dan, ko se je začela; nedokončana vožnja ni šteta. Povprečna hitrost je izračunana brez postankov med vožnjo.',
        sort_by:              'Razvrsti po: {column}',
        empty:                'V izbranem obdobju ni podatkov.',
        vehicle:              'Vozilo',
        driver:               'Voznik',
        no_driver:            'Brez voznika',
        external_driver:      'zunanji voznik',
        vehicles_driven:      'Vozila',
        average_speed:        'Povpr. km/h',
        max_speed:            'Najv. km/h',
        speeding:             'Prekoračitve',
        stops:                'Postanki',
        consumption:          'Poraba',
        odometer:             'Števec (km)',
        odometer_tracker:     'števec sledilnika',
    },
    benefit: {
        title:             'Boniteta',
        subtitle:          'Boniteta za zasebno uporabo službenega vozila (slovenski davčni predpisi)',
        month:             'Mesec',
        user:              'Uporabnik vozila',
        purchase_value:    'Nabavna vrednost (z DDV)',
        first_use:         'Datum prve uporabe',
        year_of_use:       'Leto uporabe',
        reduction:         'Znižanje',
        rate:              'Stopnja',
        base:              'Osnova',
        private_km:        'Zasebni kilometri',
        unclassified_km:   'Nerazvrščeni kilometri',
        halving:           'Znižanje do 500 km',
        fuel_supplement:   'Dodatek za gorivo',
        amount:            'Mesečna boniteta',
        alternative:       'Brez znižanja',
        uncertain:         'Ker so v mesecu nerazvrščene vožnje, je znižanje za do 500 km negotovo — prikazana sta oba zneska.',
        disclaimer:        'Informativni izračun — ne nadomešča obračuna plače.',
        unverified:        'Pravila je treba potrditi z računovodstvom.',
        confirm:           'Potrdi pravila',
        confirmed:         'Pravila so potrjena.',
        confirmed_by:      'Potrdil/a {name}, {date}',
        confirm_failed:    'Pravil ni bilo mogoče potrditi',
        rules:             'Uporabljena pravila',
        rules_edit:        'Uredi pravila',
        rules_saved:       'Pravila so shranjena.',
        rules_failed:      'Pravil ni bilo mogoče shraniti',
        rule_monthly:      'Mesečna stopnja',
        rule_ladder:       'Znižanja po letih uporabe',
        rule_low_use:      'Prag za znižanje',
        rule_low_use_cut:  'Znižanje pod pragom',
        rule_fuel:         'Dodatek za gorivo',
        rule_electric:     'Električna vozila',
        rule_zone:         'Časovni pas',
        rule_from:         'Velja od',
        rule_source:       'Vir',
        rule_unverified:   'Nepreverjeno: {rules}',
        export:            'Izvozi CSV',
        empty:             'V tem mesecu ni vozil za obračun.',
        reason_no_value:   'Ni nabavne vrednosti',
        reason_no_date:    'Ni datuma prve uporabe',
        reason_before:     'Pred prvo uporabo',
        warn_unclassified: 'Nerazvrščene vožnje',
        warn_no_driver:    'Ni uporabnika vozila',
        warn_truncated:    'Vožnje tega meseca niso bile v celoti prebrane.',
        reason_help:       'Vpiši nabavno vrednost in datum prve uporabe pri vozilu, da se boniteta lahko izračuna.',
    },
    day: {
        pick:          'Dan…',
        previous:      'Prejšnji dan',
        next:          'Naslednji dan',
        clear:         'Nazaj na obdobje',
        legend:        'Krepko so dnevi, ko je vozilo vozilo.',
        view_trips:    'Poti',
        view_day:      'Dan',
        start:         'Začetek',
        end:           'Konec',
        drives:        'voženj: {count}',
        stops:         'postankov: {count}',
        driving:       'vožnje {duration}',
        parked_before: 'Stoji od prej',
        still_parked:  'Še stoji',
        still_driving: 'Še vozi',
        speed_chart:   'Hitrost čez dan',
        no_data:       'Na ta dan ni podatkov.',
        no_driving:    'Na ta dan vozilo ni vozilo.',
        moving:        'vožnja',
        standing:      'stoji',
    },
    parameter: {
        parameters:  'Parametri',
        id:          'ID',
        name:        'Ime',
        group:       'Skupina',
        count:       'Št. zapisov',
        last_value:  'Zadnja vrednost',
        last_seen:   'Zadnjič videno',
        unknown:     'neznan parameter',
        filter:      'Filtriraj po imenu ali ID …',
        empty:       'Za to napravo še ni zabeleženih parametrov.',
        group_obd:   'OBD',
        group_oem:   'OEM',
        group_other: 'Naprava',
        vehicle_hint: 'Parametri OBD in OEM so podatki iz vozila — zaradi njih ta zajem obstaja.',
        hide_empty_slots:   'Skrij prazne reže',
        no_sensor:          'ni tipala',
        hidden_empty_slots: 'Skritih praznih rež: {count}',
    },
    record: {
        records:     'Zapisi',
        ts:          'Čas naprave',
        received_at: 'Prejeto',
        priority:    'Prioriteta',
        event:       'Dogodek',
        periodic:    'periodični',
        position:    'Položaj',
        speed:       'Hitrost',
        io:          'Elementi IO',
        io_id:       'ID',
        io_name:     'Ime',
        io_size:     'Bajtov',
        io_value:    'Vrednost',
        io_hex:      'Hex',
        io_text:     'Besedilo',
        io_empty:    'Zapis nima elementov IO.',
        load_older:  'Naloži starejše',
        no_more:     'Starejših zapisov ni več',
        empty:       'Naprava še ni poslala nobenega zapisa.',
        newest_first: 'Najnovejši na vrhu',
        asleep_hint: 'Sledilnik spi — sprejemnik GNSS je ugasnjen, zato ni določitve položaja.',
    },
    priority: {
        low:   'nizka',
        high:  'visoka',
        panic: 'panika',
    },
    packet: {
        packets:      'Surovi paketi',
        codec:        'Kodek',
        codec_8:      'Codec 8',
        codec_8e:     'Codec 8E',
        record_count: 'Zapisov',
        state:        'Razčlenjeno',
        decoded:      'Razčlenjeno',
        failed:       'Napaka',
        remote_addr:  'Naslov naprave',
        received_at:  'Prejeto',
        raw_hex:      'Surovi bajti',
        show_hex:     'Pokaži bajte',
        hide_hex:     'Skrij bajte',
        empty:        'Za to napravo ni shranjenih paketov.',
        bytes:        '{count} B',
    },
    gauges: {
        show: 'Instrumenti',
        hide: 'Skrij instrumente',
        title:        'Instrumenti',
        as_of:        'Zadnje vrednosti · {when}',
        no_data:      'Naprava še ni poslala podatkov',
        ignition_on:  'Vžig vklopljen',
        ignition_off: 'Vžig izklopljen',
        speed:        'Hitrost',
        rpm:          'Vrtljaji',
        coolant:      'Hladilna tekočina',
        fuel:         'Gorivo',
        load:         'Obremenitev',
        voltage:      'Akumulator',
        soc:          'Baterija',
        charging:     'Se polni',
        not_charging: 'Ni priklopljen',
        battery_temp: 'Temp. baterije',
        hv_voltage:   'Napetost baterije',
        hv_current:   'Tok baterije',
        soh:          'Zdravje baterije',
        range:        'Doseg',
        energy:       'Energija v bateriji',
        consumption:  'Poraba',
        lifetime_use: 'Skupna poraba',
        fuel_litres:  'Gorivo (OEM)',
        until_service: 'Do servisa',
        odometer_oem: 'Števec vozila (OEM)',
        odometer_gps: 'Števec sledilnika (GPS)',
        hint:         'Siv kazalnik pomeni, da vozilo tega podatka ne pošilja.',
        stale_hint:   'Zatemnjen kazalnik kaže zadnjo vrednost, preden je vozilo nehalo pošiljati ta podatek (npr. po izklopu vžiga).',
        stale_at:     'ob {time}',
        stale_title:  'Zadnja vrednost ob {time} — vozilo tega podatka zdaj ne pošilja.',

        style_analogue: 'Kazalniki',
        style_digital:  'Zaslon',
        drivetrain_ev:  'Elektrika',
        drivetrain_ice: 'Notranje zgorevanje',
        vin:            'VIN',
        trip:           'pot',
        range_of:       'doseg {value}',
        power_derived:  'Moč (V × A)',
        pack:           'Baterija HV',
        charging_state: 'Polnjenje',
        intake_air:     'Vstopni zrak',
        fault_codes:    'Napake (DTC)',
        movement:       'Gibanje',
        moving:         'Se premika',
        stopped:        'Miruje',
        tracker:        'Sledilnik',
        gsm:            'GSM',
        satellites:     'sat.',
    },
    speeding: {
        check:        'Omejitve',
        found:        'Prekoračitev: {count}',
        none:         'Ni prekoračitev',
        matched:      '{matched} od {total} točk ujetih na cesto z vpisano omejitvijo',
        limit_was:    'omejitev {limit}',
        unnamed_road: 'neimenovana cesta',
        unavailable:  'Omejitev ni bilo mogoče pridobiti — nič ni označeno.',
        disclaimer:   'Informativno: sled GPS, ujeta na zemljevid skupnosti, ne dokaz.',
    },
    trip: {
        found:             'Poti: {count}',
        none:              'V izbranem obdobju ni poti',
        stop_label:        'Pot se konča po',
        out:               'tja',
        back:              'nazaj',
        open:              'v teku',
        max_speed:         'največ {speed} km/h',
        stops:             'postankov: {count}',
        name_start:        'Poimenuj začetek',
        name_end:          'Poimenuj cilj',
        names_unavailable: 'Imen krajev ni bilo mogoče pridobiti z zemljevida — prikazane so koordinate.',
        truncated:         'Obdobje vsebuje več točk, kot jih je bilo prebranih: najstarejše poti manjkajo.',
        rule:              'Pot se konča, ko vozilo stoji vsaj {minutes} min.',
        presentation:      'Prikaz',
        open_replay:       'Pot še ni zaključena (vozilo mora stati {minutes} min). Predvaja se do {time}.',
    },
    replay: {
        play:           'Predvajaj pot',
        pause:          'Premor',
        restart:        'Na začetek',
        speed:          'Hitrost predvajanja',
        follow:         'Sledi vozilu',
        scrubber:       'Predvajanje poti',
        stop:           'postanek {duration}',
        badge:          'Predvajanje',
        playing:        'Predvaja',
        drive_of:       'vožnja {n} od {total}',
        continue:       'Nadaljuj na naslednjo vožnjo',
        next_drive:     'Naslednja vožnja',
        previous_drive: 'Prejšnja vožnja',
        loading_next:   'Nalagam naslednjo vožnjo…',
    },
    zone: {
        title:                 'Območja',
        subtitle:              'Isti krogi, po katerih se imenujejo poti, so tudi območja, na katera so vezana pravila alarmov.',
        add:                   'Novo območje',
        empty:                 'Ni še nobenega območja.',
        map_empty:             'Nariši prvo območje, da se pokaže na karti.',
        edit_help:             'Klikni na karto za središče, povleci rob za polmer.',
        edit_on_map:           'Uredi na karti',
        name:                  'Ime',
        name_too_long:         'Ime je predolgo.',
        kind:                  'Vrsta',
        kind_place:            'Kraj',
        kind_depot:            'Skladišče',
        kind_customer:         'Stranka',
        kind_restricted:       'Prepovedano območje',
        radius:                'Polmer',
        radius_range:          'Polmer mora biti med 25 in 2000 m.',
        note:                  'Opomba',
        note_too_long:         'Opomba je predolga.',
        saved:                 'Območje je shranjeno.',
        created:               'Območje je dodano.',
        save_failed:           'Območja ni bilo mogoče shraniti.',
        delete:                'Izbriši območje',
        delete_confirm:        'Izbrišem območje »{name}«? Poti bodo spet nosile ime naselja.',
        delete_forced_confirm: 'Ga vseeno izbrišem in odstranim iz njih?',
        deleted:               'Območje je izbrisano.',
        delete_failed:         'Območja ni bilo mogoče izbrisati.',
        in_use:                'Območja ni mogoče izbrisati, ker ga uporabljajo pravila.',
        used_by:               'Območje uporabljajo pravila: {names}.',
        no_rules:              'Nobeno pravilo ne uporablja tega območja.',
        no_zones:              'Brez območij',
        search:                'Išči po imenu ali opombi …',
        clear_search:          'Počisti iskanje',
        match_count:           '{n} od {total}',
        no_match:              'Nobeno območje se ne ujema z »{q}«.',
        on_map_count:          '{n} na karti',
        on_map:                'Na karti: {name}',
        show_on_map:           'Pokaži na karti',
        hide_on_map:           'Skrij s karte',
        show_all:              'Pokaži vse na karti',
        hide_all:              'Skrij vse',
        map_default_help:      'Na karti so privzeto samo območja IT Team. Izbira velja v tem brskalniku in ne vpliva na pravila ali imena poti.',

        rules:                  'Pravila',
        rules_subtitle:         'Pravila, ki jih napišeš sam: kdaj naj konzola javi vstop, izstop, zadrževanje, vožnjo izven delovnega časa ali prehitro vožnjo v območju.',
        rules_empty:            'Ni še nobenega pravila.',
        rule_add:               'Novo pravilo',
        rule_edit:              'Uredi pravilo',
        rule_name:              'Ime pravila',
        rule_type:              'Vrsta pravila',
        rule_zones:             'Območja',
        rule_zones_help:        'Pravilo velja za vsako izbrano območje. Največ 50.',
        rule_zones_placeholder: 'Izberi območja',
        rule_vehicles:          'Vozila',
        rule_vehicles_help:     'Prazno pomeni vsa vozila.',
        rule_saved:             'Pravilo je shranjeno.',
        rule_created:           'Pravilo je dodano.',
        rule_save_failed:       'Pravila ni bilo mogoče shraniti.',
        rule_delete:            'Izbriši pravilo',
        rule_delete_confirm:    'Izbrišem pravilo »{name}«? Odprta opozorila tega pravila se bodo zaprla.',
        rule_deleted:           'Pravilo je izbrisano.',
        rule_delete_failed:     'Pravila ni bilo mogoče izbrisati.',
        rule_enabled:           'Pravilo je vklopljeno.',
        rule_disabled:          'Pravilo je izklopljeno.',

        type_enter:          'Vstop v območje',
        type_exit:           'Izstop iz območja',
        type_dwell:          'Zadrževanje v območju',
        type_off_hours:      'Vožnja izven delovnega časa',
        type_speed:          'Prehitra vožnja v območju',
        type_enter_help:     'Javi, ko vozilo pripelje v eno od izbranih območij.',
        type_exit_help:      'Javi, ko vozilo zapusti eno od izbranih območij.',
        type_dwell_help:     'Javi, ko vozilo v območju stoji dlje od nastavljenega časa.',
        type_off_hours_help: 'Javi, ko se vozilo odpelje izven delovnega časa. Območja pri tej vrsti ne štejejo.',
        type_speed_help:     'Javi, ko vozilo v območju prekorači nastavljeno hitrost v dveh zaporednih meritvah.',

        severity:              'Resnost',
        enabled:               'Vklopljeno',
        disabled:              'Izklopljeno',
        notify_email:          'Pošlji e-pošto',
        applies:               'Velja',
        working_time:          'Delovni čas',
        working_time_required: 'Vožnja izven delovnega časa potrebuje delovni čas.',
        always:                'vedno',
        from:                  'Od',
        to:                    'Do',
        time_zone:             'Časovni pas',
        day_1:                 'pon',
        day_2:                 'tor',
        day_3:                 'sre',
        day_4:                 'čet',
        day_5:                 'pet',
        day_6:                 'sob',
        day_7:                 'ned',
        dwell_minutes:         'Zadrževanje',
        dwell_help:            'Od 5 do 1440 minut.',
        dwell_range:           'Zadrževanje mora biti med 5 in 1440 minutami.',
        speed_kmh:             'Omejitev',
        speed_help:            'Od 10 do 200 km/h. Velja samo znotraj območja.',
        speed_range:           'Omejitev mora biti med 10 in 200 km/h.',
        zones_required:        'Izberi vsaj eno območje.',
        unit_minutes:          'min',
        all_vehicles:          'Vsa vozila',
        n_vehicles:            '{count} vozilo | {count} vozili | {count} vozila | {count} vozil',
        states:                'Stanja',
        events:                'Dogodki',

        said_enter:     'Vstop v območje {zone}',
        said_exit:      'Izstop iz območja {zone}',
        said_dwell:     'Stoji v območju {zone} že {value}',
        said_off_hours: 'Vožnja izven delovnega časa',
        said_speed:     'Prehitra vožnja v območju {zone}: {value} km/h',

        builtin_hint: 'Šest vgrajenih opozoril o sledilniku in vozilu je v nastavitvah.',
        builtin_link: 'Odpri nastavitve opozoril',
    },
    stop_zone: {
        inside:   'V območju {name}',
        outside:  'Ni v nobenem območju',
        checking: 'Preverjam območja …',
        edit:     'Uredi območje',
        show:     'Pokaži območje',
        add:      'Dodaj območje',
    },
    place: {
        places:         'Imenovani kraji',
        subtitle:       'Pot, ki se začne ali konča znotraj kroga, dobi ime kraja namesto imena naselja. Nov kraj poimenuješ na koncu poti, na karti vozila.',
        empty:          'Ni še nobenega imenovanega kraja.',
        add:            'Poimenuj kraj',
        edit:           'Uredi kraj',
        delete:         'Izbriši kraj',
        delete_confirm: 'Izbrišem kraj »{name}«? Poti bodo spet nosile ime naselja.',
        deleted:        'Kraj je izbrisan.',
        delete_failed:  'Kraja ni bilo mogoče izbrisati.',
        dialog_help:    'Vsak začetek ali cilj poti znotraj tega kroga bo nosil to ime.',
        name:           'Ime',
        name_too_long:  'Ime je predolgo.',
        radius:         'Polmer',
        radius_help:    'Od 25 do 2000 m. Za dvorišče ali parkirišče zadošča 150 m.',
        radius_range:   'Polmer mora biti med 25 in 2000 m.',
        position:       'Položaj',
        on_map_hint:    'Isti krogi so tudi območja, na katera so vezana pravila alarmov.',
    },
    map_source: {
        title:              'Viri zemljevidov',
        subtitle:           'Od kod ta konzola dobi podlago karte, promet, imena krajev in omejitve hitrosti. Viri OpenStreetMap ne potrebujejo ničesar, viri TomTom pa ključ, ki se vpiše tukaj enkrat in ostane na strežniku.',
        tiles:              'Podlaga karte',
        tiles_help:         'Slikovna podlaga, na kateri je narisana vsaka karta v konzoli.',
        traffic:            'Plast prometa',
        traffic_help:       'Promet v živo, narisan čez podlago karte — katera koli ta že je. Potrebuje ključ TomTom.',
        place_names:        'Imena krajev',
        place_names_help:   'Kdo pove, kako se imenuje kraj na začetku in na koncu poti.',
        speed_limits:       'Omejitve hitrosti',
        speed_limits_help:  'Od kod pride omejitev, s katero se primerja vožnja.',
        key:                'Ključ TomTom',
        key_placeholder:    'Ključ API TomTom',
        key_stored:         'Ključ je shranjen. Pusti prazno, da ostane.',
        key_server_only:    'Ključ se shrani samo na strežniku in se brskalniku nikoli ne vrne.',
        key_required:       'Vir TomTom potrebuje ključ. Vpiši ga ali izberi vire OpenStreetMap.',
        test:               'Preizkusi ključ',
        test_ok:            'Ključ deluje.',
        test_failed:        'Ključa ni bilo mogoče uporabiti.',
        remove_key:         'Odstrani ključ',
        remove_key_confirm: 'Odstranim shranjeni ključ TomTom? Karta, plast prometa, imena krajev in omejitve hitrosti se vrnejo na OpenStreetMap.',
        source_osm:         'OpenStreetMap',
        source_nominatim:   'OpenStreetMap Nominatim',
        source_tomtom:      'TomTom',
    },
    alert: {
        title:                  'Opozorila',
        subtitle:               'Kaj je konzola opazila na vozilih: sledilnik odklopljen, prazen akumulator, napake vozila, vozilo, ki se ne javlja, gostovanje in pregrevanje.',
        open:                   'Odprta',
        resolved:               'Razrešena',
        all:                    'Vsa',
        empty:                  'Ni odprtih opozoril.',
        empty_resolved:         'Ni razrešenih opozoril.',
        empty_all:              'Ni opozoril.',
        vehicles:               'Vozilo',
        all_vehicles:           'Vsa vozila',
        acknowledge:            'Označi kot videno',
        acknowledged:           'Označeno kot videno',
        acknowledged_by:        'videl: {name}',
        opened:                 'Odprto {time}',
        resolved_at:            'Razrešeno {time}',
        load_older:             'Naloži starejša',
        no_more:                'Starejših opozoril ni več',
        severity_critical:      'Kritično',
        severity_warning:       'Opozorilo',
        severity_info:          'Informacija',
        rule_unplugged:         'Sledilnik odklopljen',
        rule_low_voltage:       'Nizka napetost akumulatorja',
        rule_fault_codes:       'Napake vozila',
        rule_silent:            'Vozilo se ne javlja',
        rule_roaming:           'Gostovanje',
        rule_overheating:       'Pregrevanje sledilnika',
        rule_unplugged_help:    'Sledilnik ne dobi več napetosti iz vtičnice OBD — nekdo ga je izvlekel iz vozila.',
        rule_low_voltage_help:  'Napetost 12 V akumulatorja vozila v mirovanju, ko vozilo stoji vsaj pol ure.',
        rule_fault_codes_help:  'Vozilo javlja shranjene kode napak (OBD).',
        rule_silent_help:       'Sledilnik ni poslal ničesar dlje, kot je dovoljeno.',
        rule_roaming_help:      'Kartica SIM je v tujem omrežju, kar podraži prenos podatkov.',
        rule_overheating_help:  'Temperatura tiskanine sledilnika je previsoka.',
        said_unplugged:         'Sledilnik je odklopljen iz vtičnice OBD',
        said_low_voltage:       'Napetost 12 V akumulatorja je {value}',
        said_fault_codes:       'Vozilo javlja {count} napako | Vozilo javlja {count} napaki | Vozilo javlja {count} napake | Vozilo javlja {count} napak',
        said_silent:            'Brez podatkov že {value}',
        said_roaming:           'Sledilnik gostuje v tujem omrežju',
        said_overheating:       'Temperatura sledilnika {value}',
        unit_hours:             'h',
        settings_title:         'Opozorila',
        settings_subtitle:      'Kaj konzola opazuje na vsakem vozilu in kdo za to izve. Pravila tečejo vsako minuto; e-pošta gre skozi strežnik, ki se vpiše tukaj enkrat in ostane na strežniku.',
        quiet_minutes:          'Tiho obdobje',
        quiet_minutes_help:     'Najmanjši razmik med dvema sporočiloma o istem vozilu in istem pravilu, v minutah. Slab spoj, ki se sproži šestkrat na uro, tako pošlje eno sporočilo.',
        mail_title:             'Obveščanje po e-pošti',
        mail_subtitle:          'Eno sporočilo na dogodek, vsem prejemnikom hkrati in nobenemu po imenu — naslovi potujejo v ovojnici, sporočilo pa jih ne razkrije.',
        mail_enabled:           'Pošiljaj obvestila po e-pošti',
        mail_incomplete:        'Obveščanje potrebuje strežnik, pošiljatelja in vsaj enega prejemnika.',
        smtp_host:              'Strežnik SMTP',
        smtp_host_placeholder:  'posta.podjetje.si',
        smtp_port:              'Vrata',
        tls_mode:               'Zaščita povezave',
        tls_mode_help:          'STARTTLS so vrata 587, TLS so vrata 465. Brez zaščite je dovoljeno samo do strežnika na zasebnem naslovu.',
        tls_starttls:           'STARTTLS',
        tls_tls:                'TLS',
        tls_none:               'Brez zaščite',
        smtp_username:          'Uporabniško ime',
        smtp_username_help:     'Pusti prazno, če strežnik ne zahteva prijave.',
        smtp_password:          'Geslo',
        password_stored:        'Geslo je shranjeno. Pusti prazno, da ostane.',
        password_server_only:   'Geslo se shrani samo na strežniku in se brskalniku nikoli ne vrne.',
        from_name:              'Ime pošiljatelja',
        from_address:           'Naslov pošiljatelja',
        from_address_placeholder: 'fleet@podjetje.si',
        recipients:             'Prejemniki',
        recipients_help:        'Največ 20 naslovov. Vpiši naslov in pritisni enter ali prilepi več naslovov naenkrat.',
        recipients_placeholder: 'naslov@podjetje.si',
        language:               'Jezik sporočil',
        language_help:          'Jezik, v katerem so napisana obvestila. Bralec sporočila nima konzole, zato se odloči tukaj.',
        time_zone:              'Časovni pas',
        time_zone_help:         'Časovni pas, v katerem so zapisani časi v sporočilih.',
        console_url:            'Naslov konzole',
        console_url_help:       'Naslov te konzole, da sporočilo lahko doda povezavo do vozila. Prazno pomeni brez povezave.',
        console_url_placeholder: 'https://vozila.podjetje.si',
        notify_resolved:        'Sporoči tudi, ko je opozorilo razrešeno',
        test_to:                'Preizkusno sporočilo na',
        test:                   'Pošlji preizkusno sporočilo',
        test_ok:                'Strežnik je sporočilo sprejel.',
        test_failed:            'Sporočila ni bilo mogoče poslati.',
        remove_password:        'Odstrani geslo',
        remove_password_confirm: 'Odstranim shranjeno geslo za SMTP? Če strežnik zahteva prijavo, obvestila ne bodo več odšla.',
        no_line_breaks:         'To polje ne sme vsebovati prelomov vrstic.',
        bad_address:            'To ni veljaven naslov e-pošte.',
        bad_url:                'Naslov se mora začeti s http:// ali https://.',
        own_rules_hint:         'Lastna pravila o območjih in delovnem času so na strani Opozorila, pod zavihkom Pravila.',
        own_rules_link:         'Odpri pravila',
        rule_reminder_due_soon: 'Opomnik zapada',
        rule_reminder_overdue:  'Opomnik je zapadel',
        reminders_enabled:      'Opozori na opomnike vozil',
        reminders_notify_email: 'Pošlji e-pošto tudi za opomnike',
        reminders_help:         'Registracije, zavarovanja, tehnični pregledi in servisi se vpišejo pri vsakem vozilu posebej.',
        reminders_link:         'Odpri opomnike',
    },
    report: {
        reports:                'Poročila',
        subtitle:               'Samodejna poročila po e-pošti: kaj gre ven, komu, kako pogosto in za katero obdobje.',
        add:                    'Novo poročilo',
        edit:                   'Uredi poročilo',
        delete:                 'Izbriši poročilo',
        deleted:                'Poročilo je izbrisano.',
        delete_failed:          'Poročila ni bilo mogoče izbrisati.',
        confirm_delete:         'Res izbrišem poročilo »{name}«? Z njim se izbriše tudi zgodovina pošiljanj.',
        empty:                  'Ni samodejnih poročil.',
        name:                   'Naziv',
        name_too_long:          'Naziv je predolg.',
        type:                   'Vrsta poročila',
        type_logbook:           'Knjiga voženj',
        type_fleet_summary:     'Pregled voznega parka',
        type_driver_summary:    'Pregled po voznikih',
        type_alerts_digest:     'Povzetek opozoril',
        hint_logbook:           'Skupki po vozilih v sporočilu, knjiga voženj za obdobje pa v prilogi CSV — ista datoteka, kot jo izvoziš na strani Poti.',
        hint_fleet_summary:     'Kaj je katero vozilo prevozilo, koliko časa in s katerim voznikom, ter kaj potrebuje pozornost.',
        hint_driver_summary:    'Iste številke, razvrščene po vozniku vsake vožnje namesto po vozilu.',
        hint_alerts_digest:     'Vsa opozorila, ki so se v obdobju odprla ali razrešila, po vozilih — in kaj je še odprto.',
        accusative_logbook:     'knjigo voženj',
        accusative_fleet_summary: 'pregled voznega parka',
        accusative_driver_summary: 'pregled po voznikih',
        accusative_alerts_digest: 'povzetek opozoril',
        frequency:              'Pogostost',
        frequency_daily:        'Dnevno',
        frequency_weekly:       'Tedensko',
        frequency_monthly:      'Mesečno',
        weekday:                'Dan v tednu',
        day_of_month:           'Dan v mesecu',
        day_of_month_help:      'Od 1 do 28, da ima dan vsak mesec — tudi februar.',
        time:                   'Ura',
        time_zone:              'Časovni pas',
        time_zone_help:         'Ura velja po tem časovnem pasu, tudi ob prehodu na poletni čas.',
        period:                 'Obdobje',
        period_previous_day:    'Pretekli dan',
        period_previous_week:   'Pretekli teden',
        period_previous_month:  'Pretekli mesec',
        period_month_to_date:   'Od začetka meseca',
        for_previous_day:       'za pretekli dan',
        for_previous_week:      'za pretekli teden (pon–ned)',
        for_previous_month:     'za pretekli mesec',
        for_month_to_date:      'od začetka meseca',
        vehicles:               'Vozila',
        all_vehicles:           'Vsa vozila',
        vehicles_help:          'Prazno pomeni vsa vozila — tudi tista, ki jih dodaš pozneje.',
        drivers:                'Vozniki',
        all_drivers:            'Vsi vozniki',
        drivers_help:           'Prazno pomeni vse voznike, vključno z vožnjami brez voznika.',
        recipients:             'Prejemniki',
        recipients_help:        'Največ 20 naslovov. Vpiši naslov in pritisni enter.',
        recipients_placeholder: 'naslov@podjetje.si',
        bad_address:            'To ni veljaven naslov e-pošte.',
        need_recipient:         'Vpiši vsaj enega prejemnika.',
        language:               'Jezik sporočila',
        attach_csv:             'Priloži CSV',
        attach_csv_help:        'Knjiga voženj gre v prilogi kot datoteka CSV.',
        enabled:                'Vklopljeno',
        every_day:              'Vsak dan ob {time}',
        every_weekday:          'Vsak {day} ob {time}',
        every_month:            '{day}. v mesecu ob {time}',
        sentence:               '{when} pošljemo {what} {period} {vehicles} na {recipients}.',
        recipient_count:        '{count} prejemnika | {count} prejemnika | {count} prejemnike | {count} prejemnikov',
        for_all_vehicles:       'za vsa vozila',
        for_some_vehicles:      'za {count} vozilo | za {count} vozili | za {count} vozila | za {count} vozil',
        with_csv:               'S prilogo CSV.',
        next_run:               'Naslednje pošiljanje',
        last_run:               'Zadnje pošiljanje',
        never_run:              'Še ni bilo poslano',
        status_sent:            'Poslano',
        status_failed:          'Ni uspelo',
        status_skipped_no_mail: 'E-pošta ni nastavljena',
        send_now:               'Pošlji zdaj',
        send_now_confirm:       'Poročilo »{name}« bo zdaj poslano prejemnikom ({count}). Nadaljujem?',
        sent:                   'Poročilo je poslano.',
        send_failed:            'Poročila ni bilo mogoče poslati.',
        preview:                'Predogled',
        preview_failed:         'Predogleda ni bilo mogoče pripraviti.',
        subject:                'Zadeva',
        html_part:              'Sporočilo',
        plain_part:             'Besedilo',
        attachment:             'Priloga',
        download:               'Prenesi',
        no_attachment:          'To poročilo nima priloge.',
        mail_missing:           'E-pošta ni nastavljena, zato samodejna poročila ne bodo poslana.',
        mail_missing_link:      'Odpri nastavitve e-pošte',
        runs:                   'Zadnja pošiljanja',
        no_runs:                'Poročilo še ni bilo poslano.',
        settings_card:          'Samodejna poročila',
        settings_hint:          'Knjiga voženj, pregled voznega parka in povzetek opozoril po e-pošti — dnevno, tedensko ali mesečno.',
        settings_link:          'Odpri poročila',
        costs:                  'Stroški',
        cost_per_km:            'Strošek na km',
        no_costs:               'brez stroškov',
        by_category:            'po kategorijah',
        costs_hint:             'Poročilo nosi tudi stroške obdobja: skupaj in po kategorijah, na vozilo pa še strošek na km. Obdobje brez vnesenih stroškov pove „brez stroškov“.',
    },
    reminder: {
        reminders:              'Opomniki',
        subtitle:               'Kaj je treba pri katerem vozilu opraviti: registracija, zavarovanje, tehnični pregled, vinjeta, servis, pnevmatike — po datumu, po kilometrih ali po obojem.',
        add:                    'Dodaj opomnik',
        edit:                   'Uredi opomnik',
        delete:                 'Izbriši opomnik',
        deleted:                'Opomnik je izbrisan.',
        delete_failed:          'Opomnika ni bilo mogoče izbrisati.',
        confirm_delete:         'Res izbrišem opomnik »{title}«?',
        confirm_history:        'Z njim se izbriše tudi zgodovina opravljenih del in stroškov. Če ga želiš samo ustaviti, ga raje izklopi.',
        empty:                  'Ni opomnikov.',
        vehicle:                'Vozilo',
        all_vehicles:           'Vsa vozila',
        type:                   'Vrsta',
        all_types:              'Vse vrste',
        title:                  'Naziv',
        title_help:             'Če pustiš prazno, se opomnik imenuje po svoji vrsti.',
        title_too_long:         'Naziv je predolg.',
        note:                   'Opomba',
        note_too_long:          'Opomba je predolga.',
        active:                 'Vklopljen',
        due_date:               'Zapade',
        due_km:                 'Pri kilometrih',
        due_help:               'Vpiši datum, stanje števca ali oboje — opomnik zapade pri tistem, kar pride prej.',
        needs_due:              'Vpiši datum ali stanje števca.',
        clear_date:             'Počisti datum',
        no_odometer:            'To vozilo ne pošilja stanja števca; opomnik po kilometrih ne bo deloval.',
        no_odometer_short:      'To vozilo ne pošilja stanja števca.',
        repeat_months:          'Ponovi čez (mesecev)',
        repeat_km:              'Ponovi čez (km)',
        lead_days:              'Opozori prej (dni)',
        lead_km:                'Opozori prej (km)',
        overdue:                'Zapadli',
        due_soon:               'Kmalu',
        ok:                     'V redu',
        inactive:               'Neaktivni',
        all:                    'Vsi',
        due_today:              'zapade danes ({date})',
        in_days:                'čez {count} dan | čez {count} dneva | čez {count} dni | čez {count} dni',
        days_ago:               'zapadlo pred {count} dnem | zapadlo pred {count} dnevoma | zapadlo pred {count} dnevi | zapadlo pred {count} dnevi',
        in_km:                  'čez {count}',
        km_at:                  'pri {at}, zdaj {now}',
        km_over:                'prekoračeno za {count} (pri {at})',
        km_unknown:             'pri {at} — vozilo ne pošilja stanja števca',
        every_months:           'vsak {count} mesec | vsaka {count} meseca | vsake {count} mesece | vsakih {count} mesecev',
        every_km:               'vsakih {count}',
        last_done:              'nazadnje {date}',
        at_km:                  'pri {at}',
        complete:               'Opravljeno',
        completed:              'Opomnik je zabeležen kot opravljen.',
        complete_failed:        'Opravljenega dela ni bilo mogoče shraniti.',
        done_at:                'Opravljeno dne',
        done_km:                'Stanje števca',
        cost:                   'Strošek',
        cost_invalid:           'Vpiši znesek, na primer 186,40.',
        next:                   'Naslednjič: {next}',
        next_or:                ' oz. ',
        next_at_km:             'pri {at}',
        next_none:              'Opomnik se po tem izklopi in ostane kot zapis o opravljenem delu.',
        all_for_vehicle:        'Vsi opomniki vozila',
        said_due_soon:          '{name} — zapade kmalu',
        said_overdue:           '{name} — zapadlo',
        type_registration:      'Registracija',
        type_insurance:         'Zavarovanje',
        type_inspection:        'Tehnični pregled',
        type_vignette:          'Vinjeta',
        type_service:           'Servis',
        type_tyres:             'Pnevmatike',
        type_custom:            'Po meri',
        cost_becomes:           'Znesek bo vpisan med stroške kot {category}.',
        completed_with_cost:    'Opravljeno; strošek {amount} je vpisan.',
        cost_link:              'Strošek: {amount}',
        open_cost:              'Odpri strošek',
    },
    units: {
        kmh:        'km/h',
        meters:     'm',
        degrees:    '°',
        celsius:    '°C',
        percent:    '%',
        volt:       'V',
        km:         'km',
        ampere:     'A',
        kwh:        'kWh',
        kwh_100km:  'kWh/100 km',
        litre:      'l',
        kw:         'kW',
        rpm:        'vrt/min',

        rpm_x1000:  '× 1000 vrt/min',
    },
    /*
     * The installation guide (`views/guide/`). Prose only: Configurator's own labels, the
     * AVL ids and the wiki addresses are the same in every language and live in
     * `libs/guide.ts`; this deployment's address comes from GET /install-info. The console's
     * own labels (menu entries, buttons, states) are passed in from their own keys, so the
     * guide always names them the way the screen does.
     */
    guide: {
        title:   'Navodila za namestitev',
        heading: 'Nastavitev sledilnika Teltonika FMC003',
        lede:    'Kako nov sledilnik FMC003 pripraviti, da pošilja podatke v to konzolo: od kartice SIM in programa Teltonika Configurator do preverjanja prve vožnje. Imena polj so navedena tako, kot jih prikazuje Configurator, v angleščini.',
        values: {
            title:         'Vrednosti, ki jih vpišete',
            domain:        'Strežnik (Domain)',
            port:          'Vrata (Port)',
            protocol:      'Protocol',
            data_protocol: 'Data protocol',
            unknown:       'Ta konzola ne pozna javnega naslova, na katerega sledilniki pošiljajo podatke. Preden začnete, naslov in vrata pridobite od skrbnika.',
            unknown_admin: 'Naslov se nastavi v okolju storitve fleet-api, s spremenljivkama TRACKER_PUBLIC_HOST in TRACKER_PUBLIC_PORT. Dokler nista nastavljeni, navodila naslova ne prikazujejo.',
            ask:           'pri skrbniku',
        },
        col: {
            field:     'Polje',
            value:     'Vrednost',
            note:      'Opomba',
            on_stop:   'Med mirovanjem (On Stop)',
            on_moving: 'Med vožnjo (On Moving)',
            symptom:   'Težava',
            cause:     'Najpogostejši vzrok',
        },
        value: {
            per_operator: 'po podatkih operaterja',
            default:      'privzeto',
        },
        before: {
            title:    'Preden začnete',
            device:   'Sledilnik FMC003 in njegov IMEI (15 števk, na nalepki sledilnika in na škatli).',
            sim:      'Kartica micro-SIM s paketom prenosa podatkov in izklopljeno kodo PIN. Od operaterja potrebujete ime APN, pri nekaterih operaterjih tudi uporabniško ime in geslo.',
            computer: 'Računalnik z Windows, najnovejši {configurator} in Teltonikini gonilniki USB (COM port drivers) ter kabel micro-USB. Namesto kabla lahko uporabite tudi Bluetooth.',
            account:  'Skrbniški račun v konzoli.',
        },
        add: {
            title:      'Dodajte vozilo v konzolo',
            intro:      'Strežnik sprejme samo sledilnike, katerih IMEI je vpisan v konzolo. Sledilnik, ki ni vpisan, bo zavrnjen že ob prvi povezavi, tudi če je vse drugo pravilno nastavljeno.',
            open:       'V konzoli odprite {vehicles} in izberite {add}.',
            fill:       'Vpišite IMEI, ime vozila in registrsko oznako. Pri električnih in hibridnih vozilih izberite še pogon, da konzola prikaže ustrezne instrumente.',
            save:       'Shranite. Strežnik nov IMEI prevzame v 30 sekundah.',
            imei_title: 'IMEI je edina zaščita.',
            imei_body:  'Strežnik sledilnik prepozna izključno po IMEI, zato IMEI ne delite zunaj ekipe. Sledilnik, ki ga ne uporabljate več, izbrišite v konzoli: s tem mu takoj onemogočite povezavo.',
            reader:     'Prijavljeni ste kot bralec: vozilo lahko doda samo skrbnik. Pošljite mu IMEI, ime vozila in registrsko oznako.',
        },
        sim: {
            title: 'Vstavite kartico SIM',
            power: 'Kartico SIM vstavljajte in odstranjujte samo, ko je sledilnik izklopljen, zunaj vtičnice OBD. Vstavljanje pod napetostjo lahko sledilnik poškoduje.',
            pin:   'Koda PIN na kartici SIM mora biti izklopljena. Če to ni mogoče, PIN vpišete v Configuratorju.',
        },
        connect: {
            title:        'Povežite sledilnik s Configuratorjem',
            usb_title:    'S kablom USB',
            usb_drivers:  'Namestite Teltonikine gonilnike COM port (samo Windows x64).',
            usb_connect:  'Priključite FMC003 s kablom micro-USB in zaženite Configurator. Sledilnik se pokaže na seznamu; izberite ga.',
            bt_title:     'Prek Bluetootha',
            bt_on:        'Bluetooth je na FMC003 privzeto vklopljen. Sledilnik se oglaša kot {prefix} in zadnjih sedem števk IMEI.',
            bt_pair:      'Seznanite ga z računalnikom. Privzeta koda PIN za seznanjanje je {pin}.',
            before_title: 'Pred spremembami',
            backup:       'Kliknite {load} in nato {save}, da shranite izvirne nastavitve.',
            firmware:     'Če Configurator ponudi novo strojno programsko opremo, jo posodobite ({update}). Za branje podatkov OEM iz vozila je potrebna različica {version} ali novejša.',
        },
        gprs: {
            title:         'GPRS: APN in strežnik',
            apn:           'Ime APN za podatkovni paket kartice SIM.',
            apn_login:     'Večina operaterjev ju ne zahteva; takrat ostaneta prazni.',
            domain:        'Javni naslov strežnika, ki sprejema podatke.',
            protocol:      'UDP strežnik ne sprejema.',
            tls:           'Izklopljeno.',
            second_server: 'Rezervni strežnik se ne uporablja.',
            ack:           'Strežnik prejete zapise potrdi na standardni Teltonikin način.',
        },
        system: {
            title:             'System: protokol in spanje',
            data_protocol:     'Obvezno. Samo Codec 8 Extended prenaša parametre z oznako, večjo od 255, npr. števec kilometrov vozila (389).',
            sleep:             'Sledilnik ostane povezan v omrežje, GPS pa se ugasne, ko vozilo miruje. Konzola takšno vozilo prikaže kot „{asleep}“.',
            without_ts:        'Zapisi brez točnega časa se ne pošljejo.',
            static_navigation: 'Odpravi „skakanje“ položaja, ko vozilo stoji.',
            sources:           'Za električna vozila glejte opombo v koraku 07.',
        },
        acquisition: {
            title:   'Data Acquisition: kako pogosto pošilja',
            path:    'Configurator › Data Acquisition › Home (enako ponovite za Roaming, če vozilo potuje v tujino)',
            intro:   'Konzola vozilo prikaže kot „{offline}“, če od sledilnika {minutes} min ne pride nič. Zato mora biti obdobje pošiljanja med mirovanjem krajše od tega.',
            derived: 'Obdobje med mirovanjem ({period} s) je izračunano iz nastavitev te konzole: tretjina tega časa, zaokrožena navzdol na celo minuto, največ 300 s.',
            outro:   'Te vrednosti dajo gladko črto vožnje na karti in prikaz v živo z zamikom približno desetih sekund, vozilo, ki stoji, pa pošlje okoli {per_day} zapisov na dan namesto več tisoč.',
        },
        obd: {
            title:         'OBD II in podatki OEM iz vozila',
            feature:       'Za vozila z motorjem z notranjim izgorevanjem.',
            feature_ev:    'Za električna vozila. Standardne poizvedbe OBD na električnem vozilu vrnejo nesmiselne vrednosti (npr. temperaturo hladilne tekočine), ta način pa uporablja samo parametre OEM proizvajalca.',
            vin:           'Če VIN ne pride, ga vpišite ročno (Manual).',
            params_title:  'Parametri, ki jih konzola uporablja',
            params_intro:  'Na zavihku {io} (in na seznamih OBD/OEM) vklopite naslednje parametre s prioriteto {low}. Konzola shrani vse, kar sledilnik pošlje, te pa prikazuje na instrumentih, v vožnjah in v opozorilih.',
            params_outro:  'Katere parametre OEM vozilo res pošilja, je odvisno od znamke in modela. Parameter, ki ga vozilo ne podpira, preprosto ne pride in ga konzola ne prikaže.',
        },
        param: {
            ignition:         'vžig',
            movement:         'premikanje',
            external_voltage: 'akumulator',
            dtc_count:        'število napak',
            fault_codes:      'kode napak',
            oem_mileage:      'km vozila',
        },
        install: {
            title: 'Shranite in vgradite',
            save:  'Kliknite {save} in nato {reboot}.',
            file:  'Nove nastavitve shranite tudi v datoteko ({save_file}). Isto datoteko lahko pozneje naložite na naslednje sledilnike ({load_file} in nato {save}) in preverite samo še APN.',
            plug:  'Sledilnik vtaknite v vtičnico OBD vozila. Nameščen mora biti tako, da ne ovira voznika. Če je vtičnica na nerodnem mestu, uporabite podaljšek OBD.',
        },
        check: {
            title:      'Preverjanje v konzoli',
            online:     'V konzoli odprite {vehicles} in vozilo. V nekaj minutah se stanje spremeni v „{online}“, „{last_record}“ pa kaže trenutni čas.',
            parameters: 'Na zavihku {parameters} preverite, ali prihajajo vžig (239), napetost akumulatorja (66) in, če ju vozilo podpira, VIN (256) in števec kilometrov vozila (389).',
            drive:      'Opravite kratko preizkusno vožnjo. Na strani {map} mora biti vozilo prikazano v vožnji, po koncu pa se vožnja pojavi na strani {trips} in na strani vozila.',
            ok_title:   'Vse je v redu, ko …',
            ok_body:    'ima vozilo na strani {map} pravilen položaj, se med vožnjo premakne na približno deset sekund, po parkiranju pa preide v stanje „{stopped}“ oziroma „{asleep}“.',
        },
        trouble: {
            title:                'Če kaj ne deluje',
            never_seen:           'Vozilo ostane „{never_seen}“',
            never_seen_cause:     'IMEI ni vpisan v konzolo ali je vpisan napačno; napačen APN; koda PIN na kartici SIM ni izklopljena; namesto TCP je izbran UDP ali pa so vrata napačna.',
            offline_parked:       '„{offline}“, ko vozilo stoji',
            offline_parked_cause: 'Obdobje pošiljanja med mirovanjem (On Stop) je daljše od {minutes} min ali pa je izbran način spanja, v katerem se sledilnik odklopi iz omrežja (Deep Sleep, Ultra Deep Sleep).',
            no_oem:               'Ni števca kilometrov vozila ne podatkov o bateriji',
            no_oem_cause:         'Na zavihku I/O vklopite parametre OEM in posodobite strojno programsko opremo. Pri električnih vozilih nastavite OBD Feature na Non-Compliant.',
            impossible:           'Instrumenti kažejo nemogoče vrednosti',
            impossible_cause:     'Električno vozilo z OBD (Auto): standardni parametri motorja nimajo smisla. Preklopite na Non-Compliant.',
            km:                   'Kilometri niso točni',
            km_cause:             'Vozilo ne pošilja števca kilometrov OEM (389), zato konzola uporablja sledilnikov števec GPS (16), ki ob vgradnji začne pri nič.',
        },
        sources: {
            title:       'Viri',
            intro:       'Imena polj in privzete vrednosti po Teltonikini dokumentaciji:',
            first_start: 'FMC003 First Start',
            gprs:        'GPRS settings',
            system:      'System settings',
            acquisition: 'Data acquisition',
            obd:         'OBD II settings',
            parameters:  'seznam parametrov',
            note:        'Configurator je lahko videti nekoliko drugače, odvisno od različice programa in strojne programske opreme.',
        },
    },
}
